// @flow

export * from './useModalConfig';
